module.exports = __webpack_public_path__ + "img/search.1cd01f24.svg";